class Alert {
    constructor() {
        this.ALERT_CLEAR_DELAY = 300;
    }
    success(message, timeout = 3000) {
        const alertElement = document.getElementById('js-alert');
        this.clearTimouts();
        alertElement.innerHTML = message;
        alertElement?.classList.remove('alert--error');
        alertElement?.classList.add('alert--show');
        this.hideAlert(alertElement, timeout);
        this.toggleAlert(alertElement);
    }
    error(message, timeout = 3000) {
        const alertElement = document.getElementById('js-alert');
        this.clearTimouts();
        alertElement.innerHTML = message;
        alertElement?.classList.add('alert--error');
        alertElement?.classList.add('alert--show');
        this.hideAlert(alertElement, timeout);
        this.toggleAlert(alertElement);
    }
    hideAlert(alertElement, timeout) {
        this.hideTimeout = setTimeout(() => {
            alertElement?.classList.remove('alert--show');
        }, timeout);
        this.clearMessageTimeout = setTimeout(() => {
            alertElement.innerHTML = "";
        }, timeout + this.ALERT_CLEAR_DELAY);
    }
    toggleAlert(alertElement) {
        alertElement.addEventListener('click', () => {
            if (alertElement.classList.contains('alert--show')) {
                this.clearTimouts();
                alertElement.classList.remove('alert--show');
            }
        });
    }
    clearTimouts() {
        clearTimeout(this.hideTimeout);
        clearTimeout(this.clearMessageTimeout);
    }
}
export default new Alert();
